export default __webpack_public_path__ + "static/media/EmergencyPerson.0f038706.svg";